module.exports = __webpack_public_path__ + "static/media/algoritmo3.f15e9d98.png";